export default "__VITE_ASSET__C1nH1lSv__"